
import { openWxFollow } from '@/settings'
import { mapGetters } from 'vuex'
import { ossUploadFile } from '@/utils/uploader'
import { UPLOAD_COMMON_TYPE } from '@/enum/uploadType'
import NewUserCoupon from "@/components/NewUserCoupon"

export default {
    computed: {
        ...mapGetters({
            thirdUserInfo: 'user/thirdUserInfo',
            infomationsImg: 'user/infomationsImg',
            // ossToken: 'ossToken',
            userinfo: 'user/userinfo'
        })
    },
    head() {
        return {
            title: this.$config.isPublicProd ? '注册-盼之代售' : '测试',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$config.isPublicProd
                        ? '盼之代售账号注册，盼之代售专业正规的游戏账号交易平台，提供网游交易售卖，手游账号买号卖号服务。王者荣耀账号出售，穿越火线cf卖号交易，英雄联盟lol买号交易，原神账号交易充值等'
                        : ''
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: this.$config.isPublicProd ? '注册，盼之代售' : ''
                }
            ]
        }
    },
    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        var noPhone = (rule, value, callback) => {
            let reg = /^1(3|4|5|6|7|8|9)\d{9}$/
            if (reg.test(value)) {
                callback(new Error('昵称不能使用手机号'))
            } else {
                callback()
            }
        }
        return {
            isShow: true,
            show: true,
            showLogo: false,
            passwordType: 'password',
            passwordNewType: 'password',

            submitLoading: false,
            form: {
                headImage: null,
                nickname: null
            },
            ruleForm: {
                mobile: '',
                qq: '',
                password: '',
                rePassword: '',
                code: ''
            },
            count: 0,
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                        required: true,
                        message: '请输入正确的手机号',
                        trigger: 'blur'
                    },
                ],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    {
                        pattern: /^[a-zA-Z0-9\.\_]+$/,
                        required: true,
                        message: '请输入重新密码',
                        trigger: 'blur'
                    }
                ],
                qq: [
                    { required: true, message: '请输入QQ号码', trigger: 'blur' },
                    {
                        pattern: /^[1-9]\d{4,10}$/,
                        required: true,
                        message: '请输入正确的QQ号码',
                        trigger: 'blur'
                    }
                ],
                rePassword: [{ required: true, validator: validatePass, trigger: 'blur' }]
            },
            rulestwo: {
                nickname: [
                    {
                        required: true,
                        message: '请输入昵称(3 到 15 个字符)',
                        trigger: 'blur'
                    },
                    {
                        min: 3,
                        max: 15,
                        message: '长度在 3 到 15 个字符',
                        trigger: 'blur'
                    },
                    { validator: noPhone, trigger: 'blur' }
                ]
            },
            checked: false,
            loginSate: false,
            regSate: true,
            smsLoading: false,
            redirect: undefined,
            cotOutModel: false,
            // 裁剪组件的基础配置option
            option: {
                img: '', // 裁剪图片的地址
                info: true, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: 'jpeg', // 裁剪生成图片的格式
                canScale: false, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 100, // 默认生成截图框宽度
                autoCropHeight: 100, // 默认生成截图框高度
                fixedBox: true, // 固定截图框大小 不允许改变
                fixed: true, // 是否开启截图框宽高固定比例
                fixedNumber: [1, 1], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: true, // 截图框能否拖动
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
                mode: 'cover' //图片默认渲染方式
            },
            loading: false,
            UPLOAD_COMMON_TYPE,
            percentage: 0,
            isShowCouponDialog: false
        }
    },
    watch: {
        $route: {
            handler: function (route) {
                this.redirect = route.query && route.query.redirect
            },
            immediate: true
        }
    },
    created() {
        if (!openWxFollow) this.showLogo = true
    },
    mounted() { },
    methods: {
        miss() {
            // 跳过后，24小时内不弹补充信息弹窗
            this.$cookies.set('countDown', Date.parse(new Date()))
            this.$router.push('/')
        },
        // 上传按钮   限制图片大小
        changeUpload(file, fileList) {
            console.log(file, fileList, '文件')
            const isLt5M = file.size / 1024 / 1024 < 5
            if (!isLt5M) {
                this.$message.error('上传文件大小不能超过 5MB!')
                return false
            }
            this.fileinfo = file
            // 上传成功后将图片地址赋值给裁剪框显示图片
            this.$nextTick(() => {
                this.option.img = window.URL.createObjectURL(file.raw)
                this.cotOutModel = true
            })
        },
        // 点击裁剪，这一步是可以拿到处理后的地址
        finish() {
            this.$refs.cropper.getCropBlob(data => {
                this.loading = true
                let _this = this
                ossUploadFile(UPLOAD_COMMON_TYPE.avatar.value, new File([data], this.fileinfo.name, { type: data.type }), {
                    ContentType: this.video ? 'video/mp4' : 'image/jpeg',
                    progress: (percentage, cpt) => {
                        this.percentage = percentage
                    }
                }).then(fileData => {
                    _this.form.headImage = fileData.url
                    this.loading = false
                    _this.cotOutModel = false
                })
            })
        },
        // 创建并登录
        createdInfo() {
            this.submitLoading = true
            if (this.checked === false) {
                this.$message.warning('请阅读并勾选《盼之代售服务协议》')
                this.submitLoading = false
                return false
            }

            if (!this.form.headImage) {
                this.$message.error('请上传头像')
                this.submitLoading = false
                return
            }
            if (!this.form.nickname) {
                this.$message.error('请填写昵称')
                this.submitLoading = false
                return
            }
            if (this.form.nickname.length > 15 || this.form.nickname.length < 3) {
                this.$message.error('昵称长度为3-15个字符')
                this.submitLoading = false
                return
            }
            let reg = /^1(3|4|5|6|7|8|9)\d{9}$/
            if (reg.test(this.form.nickname)) {
                this.$message.error('昵称不能用手机号')
                this.submitLoading = false
                return
            }
            const info = {
                action: this.form
            }
            this.$api
                .modUserInfo(info)
                .then(res => {
                    if (res.success) {
                        this.submitLoading = false
                        this.$message({
                            message: '创建成功...正在登录',
                            iconClass: 'el-icon-loading',
                            duration: 1000
                        })
                        // if (this.redirect === "/login") {
                        setTimeout(() => {
                            //
                            this.$router.push('/')
                            // this.$message.success("请继续完善个人信息");

                            this.submitLoading = false
                            this.$store.dispatch('user/UserGetInfo')
                            // } else {
                            //     this.$router.push({ path: this.redirect || "/" });
                            // }
                        }, 1500)
                        // }
                    }
                })
                .catch(err => {
                    //
                    this.$router.push('/')
                    this.submitLoading = false
                    // this.$store.dispatch("user/UserGetInfo");
                    // } else {
                    //     this.$router.push({ path: this.redirect || "/" });
                    // }
                })
        },
        random_string(len) {
            len = len || 32
            let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
            let maxPos = chars.length
            let pwd = ''
            for (let i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos))
            }
            return pwd
        },
        openHrf() {
            this.checked = !this.checked
        },
        getCode() {
            const TIME_COUNT = 60
            if (!this.timer) {
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--
                    } else {
                        this.show = true
                        clearInterval(this.timer)
                        this.timer = null
                        this.submitLoading = false
                    }
                }, 1000)
            }
        },
        submitForm(formName) {
            if (this.ie) {
                this.$message.warning('您当前使用的IE内核，为了您更好的浏览体验建议使用谷歌浏览器，或QQ浏览器切换为极速模式。')
                return
            }
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    if (this.checked === false) {
                        this.$message.warning('请阅读并勾选《盼之代售服务协议》')
                        this.submitLoading = false
                        return false
                    } else {
                        let data = {
                            action: {
                                channelCode: this.$cookies.get('pzfrom') || null,
                                phone: this.ruleForm.mobile.trim(),
                                password: this.ruleForm.password,
                                smsCode: this.ruleForm.code,
                                qq: this.ruleForm.qq,
                                openId: (this.thirdUserInfo && this.thirdUserInfo.openId) || null,
                                thirdType: (this.thirdUserInfo && this.thirdUserInfo.thirdType) || null,
                                unionId: (this.thirdUserInfo && this.thirdUserInfo.unionId) || null
                            },
                            bdVid: this.$cookies.get('bdVid') || '',
                            qhClickId: this.$cookies.get('qhClickId') || '',
                            markId: this.$cookies.get('markId') || ''
                        }
                        this.$store
                            .dispatch('user/UserRegister', data)
                            .then(res => {
                                if (res.success) {
                                    this.$message({
                                        message: '注册成功...',
                                        iconClass: 'el-icon-loading',
                                        duration: 1000
                                    })
                                    setTimeout(() => {
                                        if (res.success) {
                                            console.log(res, '注册')
                                            // this.$store.dispatch('AppGetOssAuth').then(() => {
                                            //     console.log(this.$store.getters)
                                            // })
                                            this.submitLoading = false
                                            this.$cookies.remove('bdVid')
                                            this.$cookies.remove('qhClickId')
                                            this.$cookies.remove('markId')
                                            this.$cookies.remove('pzfrom')
                                            this.$api.getImInfo().then(({ success, data }) => {
                                                if (success) {
                                                    this.$store.dispatch('ry/initConnect', data)
                                                }
                                            })

                                            // 新人优惠券： 1.注册 2.打开了优惠券开关
                                            if (res && res.data && res.data.openAward) {
                                                this.showCouponDialog()
                                                return
                                            }
                                            this.$message.success('请继续完善个人信息')
                                            this.isShow = false
                                            return false
                                        } else {
                                            this.submitLoading = false
                                            this.$message.error(res.info)
                                        }
                                    }, 1100)
                                    return false
                                } else {
                                    this.submitLoading = false
                                    this.$message.error(res.info)
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false
                            })
                    }
                } else {
                    return false
                }
            })
        },
        sendSms() {
            if (this.ruleForm.mobile === '') {
                this.$message.error('请输入手机号')
                this.$refs.phone.focus()
                return false
            } else {
                this.smsLoading = true
                let data = {
                    action: {
                        phone: this.ruleForm.mobile,
                        smsTemplate: 'REGISTER'
                    }
                }
                this.$store
                    .dispatch('user/UserSendSms', data)
                    .then(res => {
                        this.smsLoading = false
                        if (res.success) {
                            this.$message.success('验证码已发送，请注意查收')
                            this.getCode()
                            this.$refs.code.focus()
                            return false
                        } else {
                            this.$message.warning(res.info)
                        }
                    })
                    .catch(() => {
                        this.smsLoading = false
                        this.timer = null
                    })
            }
        },
        showPwd(key) {
            if (key === 'password') {
                if (this.passwordType === 'password') {
                    this.passwordType = ''
                } else {
                    this.passwordType = 'password'
                }

                this.$nextTick(() => {
                    this.$refs.password.focus()
                })
            } else {
                if (this.passwordNewType === 'password') {
                    this.passwordNewType = ''
                } else {
                    this.passwordNewType = 'password'
                }

                this.$nextTick(() => {
                    this.$refs.newPassword.focus()
                })
            }
        },
        showCouponDialog() {
            this.isShowCouponDialog = true;
        },
        closeCouponDialog() {
            this.isShowCouponDialog = false;
            this.$message.success('请继续完善个人信息')
            this.isShow = false
        }
    }
}
